// @ts-ignore
import { projectRequest } from 'store/utils/request';

import { CompareParent, MergeRequest, Conflicts } from './types';

export const compareParentRequest = async (): Promise<CompareParent> => {
  const { data } = await projectRequest.get('/version_control/parent/compare/');

  return data;
};

export const mergeRequest = async (name?: string): Promise<MergeRequest> => {
  const { data } = await projectRequest.post(
    '/version_control/merge_requests/',
    { title: name },
  );

  return data;
};

export const getParentConflictsRequest = async (): Promise<Conflicts> => {
  const { data } = await projectRequest.get(
    '/version_control/parent/conflicts/',
  );
  return data;
};

export const updateFromParentRequest = (resolvedConflicts?: Conflicts) => {
  const payload = resolvedConflicts
    ? { resolved_conflicts: resolvedConflicts }
    : undefined;
  return projectRequest.post('/version_control/parent/update/', payload);
};
